import { addMonths } from 'date-fns'
import ja from 'date-fns/locale/ja'
import ReactDatePicker, { registerLocale } from 'react-datepicker'

import { ArrowLeftSmallIcon, ArrowRightSmallIcon } from '~/components/icons'

registerLocale('ja', ja)

export const DatePicker: React.FC<{
  date?: Date | null
  minDate?: Date | null
  setDate: (date: Date | null) => void
  setIsDatepickerOpen: (boolean: boolean) => void
}> = (props) => {
  return (
    <div>
      <ReactDatePicker
        inline
        locale={ja}
        dateFormat="YYYY-MM-DD"
        selected={props.date}
        minDate={props.minDate}
        onChange={(date) => {
          props.setDate(date)
          props.setIsDatepickerOpen(false)
        }}
        renderCustomHeader={({ date, decreaseMonth, increaseMonth }) => {
          const prevMonth = addMonths(date, -1)
          const nextMonth = addMonths(date, 1)
          return (
            <div className="flex items-center justify-between px-14 my-4 text-base">
              <button
                type="button"
                className="flex items-center gap-1 border border-black rounded-sm px-2 py-1 font-bold text-xs"
                onClick={decreaseMonth}
              >
                <ArrowLeftSmallIcon className="fill-black w-4 h-4" />
                {prevMonth.getMonth() + 1}月
              </button>
              <div className="flex justify-center font-bold">
                <div>{date.getFullYear()}年</div>
                <div>{date.getMonth() + 1}月</div>
              </div>
              <button
                type="button"
                className="flex items-center gap-1 border border-black rounded-sm px-2 py-1 font-bold text-xs"
                onClick={increaseMonth}
              >
                {nextMonth.getMonth() + 1}月{' '}
                <ArrowRightSmallIcon className="fill-black w-4 h-4" />
              </button>
            </div>
          )
        }}
      />
    </div>
  )
}
